import { radius } from '@alison/ui';
import SnoozeIcon from '@mui/icons-material/Snooze';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';
import { type ReactNode, useState } from 'react';

export function QuietHours(): ReactNode {
  const [quietHoursEnabled, setQuietHoursEnabled] = useState(true);

  return (
    <Stack
      direction="row"
      sx={{
        alignItems: 'center',
        gap: 2,
        mt: 3,
        p: 3,
        bgcolor: 'background.platform',
        borderRadius: `${radius.lg}px`,
      }}
    >
      <Box
        sx={{
          width: 34,
          height: 34,
          borderRadius: `${radius.lg}px`,
          bgcolor: 'background.paper',
          color: 'text.secondary',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          boxShadow: 1,
        }}
      >
        <SnoozeIcon sx={{ fontSize: 16 }} />
      </Box>
      <Box sx={{ flex: 1 }}>
        <Typography sx={{ fontSize: 13, fontWeight: 700, color: 'text.primary' }}>
          Quiet hours
        </Typography>
        <Typography sx={{ fontSize: 12, color: 'text.secondary' }}>
          Pause non-urgent notifications overnight. Operational alerts still come through.
        </Typography>
      </Box>
      <Stack direction="row" sx={{ alignItems: 'center', gap: 2 }}>
        {quietHoursEnabled && (
          <Typography
            sx={{
              fontSize: 12,
              fontWeight: 600,
              color: 'text.primary',
              fontVariantNumeric: 'tabular-nums',
            }}
          >
            10:00 PM – 7:00 AM
          </Typography>
        )}
        <Switch
          checked={quietHoursEnabled}
          onChange={() => setQuietHoursEnabled((current) => !current)}
          slotProps={{ input: { 'aria-label': 'Enable quiet hours' } }}
        />
      </Stack>
    </Stack>
  );
}
